import axios from 'axios';
import {backendHost} from '../../config';

export const getInviteById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/invite/${params.id}`);
};